<template>
    <div class="horizontal grow gallery-container" style="min-width: 700px; width: 50vw; height: 70vh">
            <div id="info-container">
                <div>
                    <p class="section-title">{{ title }}</p>
                    <div>
                        <!-- NAME -->
                        <div class="info-field horizontal">
                            <tr class="info-field-row">
                                <td style="width:200px;"><p class="info-field-title">{{$t('FirstName')}}</p></td>
                                <td style="width:200px;" class="info-field-value">
                                    <input v-model="user.Name" type="text" :placeholder="$t('FirstName')">
                                </td>
                            </tr>
                        </div>
                        <!-- SURNAME -->
                        <div class="info-field horizontal">
                            <tr class="info-field-row">
                                <td style="width:200px;"><p class="info-field-title">{{$t('Surname')}}</p></td>
                                <td style="width:200px;" class="info-field-value">
                                    <input v-model="user.Surname" type="text" :placeholder="$t('LastName')">
                                </td>
                            </tr>
                        </div>
                        <!-- EMAIL -->
                        <div class="info-field horizontal">
                            <tr class="info-field-row">
                                <td style="width:200px;"><p class="info-field-title">{{$t('Email')}}</p></td>
                                <td style="width:200px;" class="info-field-value">
                                    <input v-model="user.Email" type="email" :placeholder="$t('Email')">
                                </td>
                            </tr>
                        </div>
                        <div class="info-field horizontal">
                            <tr class="info-field-row">
                                <td style="width:200px;"><p class="info-field-title">{{$t('ExpirationDate')}}</p></td>
                                <td style="width:200px;" class="info-field-value">
                                    <date-picker style="width: 100%;" :confirm="false" v-model="user.expirationDate" :type="'date'" :clearable="false" :format="'DD-MM-YYYY'"></date-picker>
                                </td>
                            </tr>
                        </div>
                        <div class="info-field horizontal">
                            <tr class="info-field-row">
                                <td style="width:200px;"><p class="info-field-title">{{$t('EmailsLanguage')}}</p></td>
                                <td style="width:200px;" class="info-field-value">
                                    <select v-model="user.language">
                                        <option selected>English</option>
                                        <option>Norwegian</option>
                                    </select>
                                </td>
                            </tr>
                        </div>
                        <!-- ACCESS TO SYSTEMS -->
                        <div class="info-field horizontal">
                            <tr class="info-field-row">
                                <td style="width:200px;"><p class="info-field-title">{{$t('AccessToSystems')}}</p></td>
                                <td style="width:200px;" class="info-field-value">
                                    <div v-for="(sys, index) in access" :key="index">{{ sys.systemName }}</div>
                                </td>
                            </tr>
                        </div>
                        <!-- ACCESS TO SYSTEMS -->
                        <div class="info-field horizontal">
                            <tr class="info-field-row">
                                <td style="width:200px;"><p class="info-field-title">{{$t('AccessByGroups')}}</p></td>
                                <td style="width:200px;" class="info-field-value">
                                    <div v-for="(sys, index) in sysGroups" :key="index">{{ sys.name }}</div>
                                </td>
                            </tr>
                        </div>
                        <div>
                            <div class="error" v-if="error != ''">{{ error }}</div>
                        </div>
                    </div>
                </div>
                <div style="align-self: center;">
                    <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
                </div>
            </div>
            <div id="systems-container" style="display: block;">
                <h4 style="padding-top: 10px;">{{$t('Systems')}}</h4>
                <div style="height: 44%; width: 90%; margin: auto; padding: 0 0 10px 0;">
                    <ejs-grid ref="modal_grid" height='100%' width='100%' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="systems" :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :showBusyIndicator="true" :rowSelected="selectionChanged" :rowDeselected="selectionChanged">
                        <e-columns>
                            <e-column type='checkbox' width='50' headerText='Discontinued' textAlign='Left'></e-column>
                            <e-column field='systemName' :headerText="$t('SystemName').toUpperCase()" textAlign='Left'></e-column>
                            <e-column field='country' :headerText="$t('Country').toUpperCase()" textAlign='Left' :filter="filterCheckbox"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                <h4>{{$t('Groups')}}</h4>
                <div style="height: 44%; width: 90%; margin: auto; padding: 0 0 10px 0;">
                    <ejs-grid ref="groups_grid" height='100%' width='100%' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="groups" :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :showBusyIndicator="true" :rowSelected="groupsSelectionChanged" :rowDeselected="groupsSelectionChanged">
                        <e-columns>
                            <e-column type='checkbox' width='50' headerText='Discontinued' textAlign='Left'></e-column>
                            <e-column field='name' :headerText="$t('NAME')" textAlign='Left'></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </div>
    </template>

    <script>
    import { Sort, Page, Filter, Toolbar, Search, CommandColumn } from '@syncfusion/ej2-vue-grids';
    import { getSystemsWithCountries, getExistingGroups, createInvitation, GetSystemNames, updateInvitation } from '@/api/api'
    import Button from '../Button.vue';
    import Select from '../Select'
    import DatePicker from 'vue2-datepicker';

    var now = new Date();

    export default {
        props: ['userObject', 'title'],
        components: {
            Button,
            Select,
            DatePicker
        },
        provide: {
            grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn ]
        },
        data() {
            return {
                user: {
                    Name: '',
                    Surname: '',
                    Email: '',
                    expirationDate: new Date(now.setDate(now.getDate() + 7)),
                    accessToSystems: [],
                    systemGroups: [],
                    language: 'English'
                },
                systems: [],
                groups: [],
                error: "",
                systemNames: [],

                wrapSettings: { wrapMode: 'Content' } ,
                selectionOptions: { type: 'Multiple' },
                filterOptions: {
                    type: 'Menu'
                },
                filterCheckbox: {
                    type: "CheckBox",
                },
            }
        },
        computed: {
            access(){
                return this.user.accessToSystems;
            },
            sysGroups() {
                return this.user.systemGroups
            }
        },
        methods: {
            async getData() {
                this.systems = await getSystemsWithCountries();
                this.groups = await getExistingGroups();
                this.systemNames = await GetSystemNames();

                if (this.userObject != null) {
                  this.user.Name = this.userObject.fullName.split(' ')[0];
                  this.user.Surname = this.userObject.fullName.split(' ')[1];
                  this.user.Email = this.userObject.email;
                  this.user.expirationDate = new Date(this.userObject.expirationDate);
                  this.user.accessToSystems = this.userObject.systems;
                  this.user.systemGroups = this.userObject.systemGroups;
                  this.user.language = ['English', 'Norwegian'][this.userObject.language];
                  this.user.id = this.userObject.id;

                  if (this.user.accessToSystems != null && this.user.accessToSystems.length > 0) {
                    var systemsIndex = []
                    var systemsnames = this.systems.map(x => x.systemName);
                    for (let i = 0; i < this.user.accessToSystems.length; i++) {
                      var g = this.user.accessToSystems[i]
                      var idx = systemsnames.indexOf(g.name)
                      systemsIndex.push(idx)
                    }

                    this.$refs.modal_grid.selectRows(systemsIndex);
                  }

                  if (this.user.systemGroups != null && this.user.systemGroups.length > 0) {

                    var groupsIndexes = []
                    var groupnames = this.groups.map(x => x.name);
                    for (let i = 0; i < this.user.systemGroups.length; i++) {
                      var g = this.user.systemGroups[i]
                      var idx = groupnames.indexOf(g.name)
                      groupsIndexes.push(idx)
                    }

                    this.$refs.groups_grid.selectRows(groupsIndexes)
                  }
                }
            },
            groupsSelectionChanged() {
                this.user.systemGroups = []
                this.user.systemGroups = this.$refs.groups_grid.getSelectedRecords();
            },
            selectionChanged() {
                this.user.accessToSystems = [];
                this.user.accessToSystems = this.$refs.modal_grid.getSelectedRecords();
            },
            dataBound: function() {
                this.$refs.modal_grid.autoFitColumns();
            },
            async save() {
                this.checkRequirements()

                if(this.error != '') {
                    return;
                }

                var systemConnections = []

                systemConnections = systemConnections.concat(this.user.accessToSystems.map(x => {
                    return {
                        ConnectionId: x.id,
                        Mode: 0
                    }
                }))
                systemConnections = systemConnections.concat(this.user.systemGroups.map(x => {
                    return {
                        ConnectionId: x.id,
                        Mode: 1
                    }
                }))

                try {

                    if (this.userObject == null) {
                      await createInvitation({
                        Name: this.user.Name,
                        Surname: this.user.Surname,
                        Email: this.user.Email,
                        ExpirationDate: this.user.expirationDate,
                        Language: ['English', 'Norwegian'].indexOf(this.user.language),
                        Connections: [...systemConnections]
                      })
                    } else {
                      await updateInvitation({
                        Id: this.user.id,
                        Name: this.user.Name,
                        Surname: this.user.Surname,
                        Email: this.user.Email,
                        ExpirationDate: this.user.expirationDate,
                        Language: ['English', 'Norwegian'].indexOf(this.user.language),
                        Connections: [...systemConnections]
                      })
                    }

                    this.$emit('save')
                } catch (server_exception) {
                    this.error = server_exception
                }

            },
            isEmailValid() {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                var isEmail = re.test(String(this.user.Email).toLowerCase());

                if(this.user.Email.length === 0) {
                    this.error = 'Email is required.'
                    return false;
                } else if(!isEmail) {
                    this.error = 'Email is in not valid format.'
                    return false;
                } else {
                    this.error = ''
                    return true;
                }
            },
            checkRequirements() {
                this.error = ''

                if(!this.isEmailValid()){
                    return;
                }

                if (this.user.accessToSystems.length == 0 && this.user.systemGroups.length == 0) {
                    this.error = 'Select at least one system lub group.'
                    return;
                }
            },
            processError(error){
                // console.log(error)
                if(error.response.data[0] != undefined){
                    this.error = error.response.data[0].description
                } else {
                    // console.log({err: error.response})
                    this.error = ""
                    if(error.response.data.errors.Password != undefined) {
                        this.error = error.response.data.errors.Password[0]
                    } else if (error.response.data.errors.Email != undefined) {
                        this.error = error.response.data.errors.Email[0]
                    }
                }

            }
        },
        mounted: async function() {
            this.getData();
        }
    }
    </script>

    <style scoped>
    h4 {
        text-align: center;
        font-size: 18px;
    }

    .error {
        text-align: left !important;
        color: #FD8282;
        font-size: 11px;
        font-weight: bold;
        font-family: 'Open Sans', sans-serif !important;
        font-style: normal !important;
        font-weight: 400 !important;
    }

    #info-container {
        width: 50%;
        padding: 20px;

        background: #FFFFFF;
        border: 1px solid #EFEFEF;
        box-sizing: border-box;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
        border-radius: 5px 0px 0px 5px;

        justify-content: space-between;
        display: flex;
        flex-direction: column;
    }

    #systems-container {
        width: 50%;
        align-items: center;
        justify-content: center;
        /* margin: auto; */
    }

    .gallery-container {
        background: #F9F9F9;
        box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
        border-radius: 5px;
    }

    .info-field {
        border-bottom: 1px solid #E9E9E9;
        margin-bottom: 12px;
        margin-top: 12px;
    }

    .info-field-title {
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;

        color: #272727;
        margin: 0;
    }

    .info-field-row {
        width: 100%;
        margin: 0;
        padding-bottom: 5px;
    }

    .info-field-value {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;

        color: #272727;
    }

    .section-title {
        font-weight: bold;
    }

    input[type=text], input[type="email"], input[type="password"] {
        border: none;
        width: 100%;
    }

    input[type=text]:focus, input[type="email"]:focus, input[type="password"]:focus {
        border-bottom: 1px solid #0095b2;
        outline: none;
    }

    select {
        border: none;
        width: 100%;
    }

    select:focus {
        outline: none;
        border-bottom: 1px solid #0095b2;
    }

    option {
        padding: 4px;
    }

    option:checked {
        background: #347C93;
        color: white;
    }
    </style>



// WEBPACK FOOTER //
// src/components/Users/AddInvitationModal.vue